import { ButtonBase, Stack, useMediaQuery, useTheme } from "@mui/material"
import { useMemo } from "react"
import { Story } from "../../../models/stories.models"
import ProgressBar from "../../global/ProgressBar"
import { ChevronRightRounded } from "@mui/icons-material"
import { colors } from "../../../services/config/colors"

interface StoryTimelineProps {
  story: Story
  currentSlideCounter: number
  goForward: () => void
}

export const StoryTimeline = ({
  story,
  currentSlideCounter,
  goForward,
}: StoryTimelineProps) => {
  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"))

  // progress bar target
  const target = useMemo(() => story.slides.length, [story])

  return (
    <Stack
      gap={2}
      direction="row"
      alignItems="center"
      justifyContent="center"
      style={{
        width: matchesMD ? "100%" : 375,
        height: matchesMD ? 62 : 7,
        minHeight: matchesMD ? 62 : 7,
      }}
    >
      <ProgressBar
        current={currentSlideCounter}
        target={target}
        hidePercentage
        containerStyle={{ height: 7, minHeight: 7 }}
        barStyle={{ transition: "300ms" }}
      />
      {matchesMD && (
        <ButtonBase
          style={{
            width: 30,
            minWidth: 30,
            height: 30,
            backgroundColor: colors.primary,
            borderRadius: "100%",
            border: `2px solid ${colors.backgroundWhite}`,
          }}
          onClick={goForward}
        >
          <ChevronRightRounded style={{ color: colors.textWhite }} />
        </ButtonBase>
      )}
    </Stack>
  )
}
